const SdeskMcpConstant = {
    SDESK_MCP_TOKEN_SECRET_KEY: 'sdeskMcptoken_secret_key', // 24 characters -> AES-192
    SDESK_MCP_TOKEN_KEY_IV: 'sdeskMcpToken_IV', //max 16 characters

    SDESK_TOKEN_TYPE: {
        SDESK_MCP: 'SDESK_MCP'
    },

    SDESK_TOKEN_STATUS: {
        ACTIVE: 'ACTIVE',
        INACTIVE: 'INACTIVE'
    },

    MCP_WARNING_PREFIX: '[MCP_WARNING]',
};

export default SdeskMcpConstant;
